module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("EDI TEAM Execution (" + _vm._s(_vm.EdiExecutionModel.ccType) + ")")]), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Import') ? _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.mainEntryData[0].shippingArrivalNoticmailSentDate == null) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.SendShipmentArrival
    }
  }, [_vm._v("Send Shipment Arrival Notice")]) : _vm._e()], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.multipleUpload.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Uploaded Checklist")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "ffBookingTentative"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Remark")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("View Uploaded File")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.multipleUpload), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Remark == '' ? '--' : item.Remark))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(index == 0 ? item.status : "Not Approved"))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.viewdoc(item.checklistUpload)
        }
      }
    }, [_c('md-icon', [_vm._v("visibility")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.editable(item, index)
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.viewApprove), function(item3, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "30"
      }
    }, [(_vm.EdiExecutionModel.ccType == 'Export') ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item3,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Import_Uploads/" + item3,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Shipping Bill Details")]), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload SB Documents")])], 1)]), _vm._v(" "), _vm._l((_vm.multiShippingBill), function(itemSB, index) {
    return _c('div', {
      key: index
    }, [_c('b-card', {
      staticClass: "mt-3",
      staticStyle: {
        "background": "whiteSmoke"
      }
    }, [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "30"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.EdiExecutionModel.ccType == 'Export' ? "Shipping Bill No *" : 'Bill Of Entry No.(BOE) *'))]), _vm._v(" "), _c('b-input', {
      attrs: {
        "name": "Remark",
        "id": "Remark"
      },
      model: {
        value: (itemSB.sbNo),
        callback: function($$v) {
          _vm.$set(itemSB, "sbNo", $$v)
        },
        expression: "itemSB.sbNo"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.EdiExecutionModel.ccType == 'Export' ? "Shipping Bill" : 'BOE') + " Date * ")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "bookingDate",
        "name": "bookingDate"
      },
      model: {
        value: (itemSB.sbDate),
        callback: function($$v) {
          _vm.$set(itemSB, "sbDate", $$v)
        },
        expression: "itemSB.sbDate"
      }
    })], 1)], 1), _vm._v(" "), _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "30"
      }
    }, [_c('label', [_vm._v("Shipper Invoice No")]), _vm._v(" "), _c('b-input', {
      attrs: {
        "name": "Remark",
        "id": "Remark"
      },
      model: {
        value: (itemSB.shipperInvNo),
        callback: function($$v) {
          _vm.$set(itemSB, "shipperInvNo", $$v)
        },
        expression: "itemSB.shipperInvNo"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("Shipper Invoice Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "bookingDate",
        "name": "bookingDate"
      },
      model: {
        value: (itemSB.shipperInvDate),
        callback: function($$v) {
          _vm.$set(itemSB, "shipperInvDate", $$v)
        },
        expression: "itemSB.shipperInvDate"
      }
    })], 1)], 1), _vm._v(" "), (_vm.mainEntryData[0].containerSealed == 'WareHouse') ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "50"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("CRN No.")]), _vm._v(" "), _c('b-input', {
      attrs: {
        "name": "Remark",
        "id": "Remark"
      },
      model: {
        value: (itemSB.crnNo),
        callback: function($$v) {
          _vm.$set(itemSB, "crnNo", $$v)
        },
        expression: "itemSB.crnNo"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("Carting Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "bookingDate",
        "name": "bookingDate"
      },
      model: {
        value: (itemSB.cartingDate),
        callback: function($$v) {
          _vm.$set(itemSB, "cartingDate", $$v)
        },
        expression: "itemSB.cartingDate"
      }
    })], 1)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "md-fab md-fab",
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.addAdditionalHBL
    }
  }, [_vm._v("Add More SB ")])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "vgmBy"
    }
  }, [_vm._v("VGM By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.vgmByList,
      "option-value": "vgmByValue",
      "option-text": "vgmByText",
      "placeholder": "Select",
      "name": "vgmBy",
      "id": "vgmBy"
    },
    model: {
      value: (_vm.EdiExecutionModel.vgmBy),
      callback: function($$v) {
        _vm.$set(_vm.EdiExecutionModel, "vgmBy", $$v)
      },
      expression: "EdiExecutionModel.vgmBy"
    }
  })], 1), _vm._v(" "), (_vm.EdiExecutionModel.vgmBy == 'SHIPPER') ? _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.EdiExecutionModel.vgmBy == 'SHIPPER') ? _c('b-button', {
    staticStyle: {
      "margin-top": "35px !important"
    },
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload Shipper VGM")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.viewVgmDoc.length > 0 || _vm.viewVgmDoc.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.viewVgmDoc), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "45"
      }
    }), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Export') ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])], 1)
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " gutr"
  }, [_c('div', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('0')
      }
    }
  }, [_vm._v("Save & Submit")])], 1), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Export' && _vm.containerCheck == true) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderBL"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('BL')
      }
    }
  }, [_vm._v("Save & Proceed to BL")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderBL"
    }
  })], 1)]), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Export' && _vm.containerCheck == true) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderHand"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('handover')
      }
    }
  }, [_vm._v(_vm._s(_vm.portType == 'Sea_Port' ? "Save & Proceed to Gate-in-at Terminal by Road" : "Save & Proceed to Handover"))]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderHand"
    }
  })], 1), _vm._v(" "), _c('div', [(_vm.EdiExecutionModel.ccType == 'Import') ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVgm"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('vgm')
      }
    }
  }, [_vm._v("Save & Proceed To Execution")]) : _vm._e(), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Export' && _vm.EdiExecutionModel.vgmBy != 'SHIPPER' && _vm.containerCheck == true) ? _c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderVgm"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('vgm')
      }
    }
  }, [_vm._v("Save & Proceed To VGM")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderVgm"
    }
  })], 1), _vm._v(" "), (_vm.EdiExecutionModel.ccType == 'Export' && _vm.containerCheck == false && _vm.EdiExecutionModel.ediExecutionId != '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("Note: Please Enter All Container Details on First Page To proceed Further..!")]) : _vm._e()], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.Onclose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "message",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1950168e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/ediExecution.vue
// module id = 2421
// module chunks = 0